module.exports = __webpack_public_path__ + "static/img/拍照.f9bf85e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/拍照.png
// module id = 114
// module chunks = 382